'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoKey = function IoKey(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.8 23.5c2.1 1.3 3.7 3.8 3.7 6.5 0 4.1-3.4 7.5-7.5 7.5s-7.5-3.4-7.5-7.5c0-2.8 1.5-5.2 3.8-6.6 0 0 0.5-1.2 0.9-3.2 0-0.3 0.8-0.4 0.8-0.9v-1.6c0-0.4-0.5-0.7-0.5-0.8v-1.3c0-0.1 0-0.3 0.1-0.4 0-0.1 0.1-0.1 0.1-0.2l0.1-0.1 0.3-0.3v-0.1c0.2-0.1 0.3-0.3 0.3-0.4 0-0.1 0-0.7 0-0.7 0-0.3-0.1-0.5-0.3-0.7l-0.4-0.4c-0.2-0.2-0.3-0.4-0.3-0.7v-0.5c0-0.2 0.2-0.6 0.3-0.7l0.4-0.4c0.2-0.2 0.3-0.2 0.3-0.5v-1.8c0-0.3-0.1-0.5-0.3-0.7v0l-0.4-0.4c-0.1-0.2-0.2-0.4-0.2-0.7v-1.4c0-0.8 0-1.5 0.7-1.8 0.2 0 1.1-0.2 1.8-0.2 1.6 0 2.3 0.6 2.5 2.8 0 0 0.5 6.3 0.7 11.2s0.6 7 0.6 7z m-3.8 11.5c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z' })
        )
    );
};

exports.default = IoKey;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/key.js
// module id = 2563
// module chunks = 0